export default {
  all: [0, 1, 2],
};
